import React, { useEffect, useState } from "react";
import {
  ProjectUbicacionDistance,
  ProjectUbicacionProps,
} from "../../../interfaces/projects";
import { transformCloudinaryImg } from "../../../services/utils";
import SlideInDown from "../../Animations/slideInDown";
import Width from "../../Animations/width";
import Icon from "../Icon";
import Map from "../Map";
import { ScaledText } from "../ScaledText";
import VideoLazy from "../Video";
import "./ubicacion.scss";

const ProjectsUbicacion: React.FC<ProjectUbicacionProps> = ({
  title,
  description,
  colors,
  image,
  video,
  location,
  distances,
  geo: { lat, lng },
}) => {
  const [bgImage, setBgImg] = useState<string>("");
  const [opacity, setOpacity] = useState<any>({});
  const [hideText, setHideText] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const { clientWidth } = document.documentElement;
      setBgImg(
        transformCloudinaryImg(
          image,
          clientWidth <= 768 ? "f_auto,q_70,h_600" : "f_auto,q_70,w_1920"
        )
      );
    }
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (typeof window !== `undefined`) {
        const el = document.getElementById("ubicacion");
        const vh40 = document.documentElement.clientHeight * 0.25;

        if (window.pageYOffset - el.offsetTop + vh40 >= 0) {
          const movibleWrap = document.getElementById("movible-wrap-ubicacion");
          const movibleEl = document.getElementById("movible-ubicacion");
          const opacity =
            ((((movibleEl.offsetTop + movibleEl.clientHeight) * 100) /
              movibleWrap.clientHeight -
              100) *
              -1) /
            100;
          const grayscale =
            (((movibleEl.offsetTop + movibleEl.clientHeight) * 100) /
              movibleWrap.clientHeight -
              100 * -1) /
              100 -
            1;
          setOpacity({
            opacity,
            filter: `grayscale(${grayscale > 0.25 ? grayscale : 0})`,
          });
        } else {
          setOpacity({ opacity: 1, filter: `grayscale(${0})` });
        }

        if (
          window.pageYOffset - el.offsetTop >= 0 &&
          video &&
          video.url &&
          !hideText
        ) {
          // desaparece el texto luego de 7 segundos
          setTimeout(() => {
            setHideText(true);
          }, 7000);
        }
      }
    };
    if (typeof window !== `undefined`) {
      window.addEventListener("scroll", onScroll);
    }
    return () => {
      if (typeof window !== `undefined`) {
        return window.removeEventListener("scroll", onScroll);
      }
    };
  }, []);

  return (
    <section className="ubicacion" id="ubicacion">
      <div className="container">
        <div className="movible-wrap" id="movible-wrap-ubicacion">
          <div className="movible" style={opacity} id="movible-ubicacion">
            <ScaledText text="UBICACIÓN" />
          </div>
        </div>
      </div>

      <div
        className={`ubicacion-data ${hideText ? "hide-text" : null}`}
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        {video && <VideoLazy poster={video.poster} url={video.url} />}
        <div className="container">
          <SlideInDown distance={50} duration={0.6}>
            <h3
              className="font-bold"
              style={{ color: colors.contrast }}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </SlideInDown>
          <Width width="500px" widthMobile="80%" delay={0.3}>
            <hr
            // style={{
            //   borderColor: colors.secondary,
            //   backgroundColor: colors.secondary,
            // }}
            />
          </Width>
          <SlideInDown distance={50} duration={0.6}>
            <p
              style={{ color: colors.contrast }}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </SlideInDown>
        </div>
      </div>

      <div className="container">
        <div className="map-container">
          <div className="location">
            <div className="marker">
              <Icon name="marker" />
            </div>
            <h4 style={{ color: colors.primary }}>{location}</h4>
            {distances && (
              <div className="distances" style={{ color: colors.primary }}>
                <div className="font-bold text-uppercase">DISTANCIAS:</div>
                <ul className="font-medium">
                  {distances.map(
                    (distance: ProjectUbicacionDistance, i: number) => (
                      <li key={i}>{distance.distance}</li>
                    )
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      <Map lat={lat} lng={lng} />
    </section>
  );
};

export default ProjectsUbicacion;
